export const studentInformation = {
  name: "أحمد سعد",
  nameEn: "Ahmed Saad",
  phone: "0551233214",
  educationLevel: "الصف الأول متوسط",
  educationLevelEn: "First grade of middle school",
};

export const feeDetails = [
  {
    title: "رسوم الأقساط المدرسية",
    titleEn: "Tuition Fees",
    price: 152,
  },
  { title: "رسوم الكتب", titleEn: "Book Fees", price: 152 },
  {
    title: "رسوم المواصلات",
    titleEn: "Transportation Fees",
    price: -260,
  },
  {
    title: "رسوم الأكاديمية",
    titleEn: "Academic Fees",
    price: -260,
  },
  {
    title: "رسوم حجز المقعد",
    titleEn: "Seat Reservation Fees",
    price: -260,
  },
  { title: "رسوم أخرى", titleEn: "Other Fees", price: -260 },
];

export const installmentDetails = [
  { title: "الترم الأول", titleEn: "First Semester", price: 12800 },
  { title: "الترم الثاني", titleEn: "Second Semester", price: 12800 },
  { title: "الترم الثالث", titleEn: "Third Semester", price: 12800 },
];
